import { call, put, takeEvery } from 'redux-saga/effects';
import {
    FETCH_ACTIVITY_REFERENCES_REQUEST,
    FETCH_ACTIVITY_REFERENCES_SUCCESS,
    FETCH_ACTIVITY_REFERENCES_FAILURE,
    FETCH_ACTIVITY_REFERENCE_BY_ID_REQUEST,
    FETCH_ACTIVITY_REFERENCE_BY_ID_SUCCESS,
    FETCH_ACTIVITY_REFERENCE_BY_ID_FAILURE,
    CREATE_ACTIVITY_REFERENCE_REQUEST,
    CREATE_ACTIVITY_REFERENCE_SUCCESS,
    CREATE_ACTIVITY_REFERENCE_FAILURE,
    UPDATE_ACTIVITY_REFERENCE_REQUEST,
    UPDATE_ACTIVITY_REFERENCE_SUCCESS,
    UPDATE_ACTIVITY_REFERENCE_FAILURE,
    DELETE_ACTIVITY_REFERENCE_REQUEST,
    DELETE_ACTIVITY_REFERENCE_SUCCESS,
    DELETE_ACTIVITY_REFERENCE_FAILURE,
} from '../actions/dataActions';
import {
    getActivityReferences,
    getActivityReferenceById,
    createActivityReference,
    updateActivityReference,
    deleteActivityList,
} from '../../services/api';
import { handleApiError } from '../../utils/errorHandler';

/**
 * Saga pour récupérer toutes les références d'activité
 */
function* fetchActivityReferencesSaga(action) {
    try {
        const params = action.payload || {};
        const data = yield call(getActivityReferences, params);
        yield put({ type: FETCH_ACTIVITY_REFERENCES_SUCCESS, payload: data });
    } catch (error) {
        const errorMessage = handleApiError(error, 'Erreur lors du chargement des références d\'activité');
        yield put({ type: FETCH_ACTIVITY_REFERENCES_FAILURE, payload: errorMessage });
    }
}

/**
 * Saga pour récupérer une référence d'activité par ID
 */
function* fetchActivityReferenceByIdSaga(action) {
    try {
        const referenceId = action.payload;
        const data = yield call(getActivityReferenceById, referenceId);
        yield put({ type: FETCH_ACTIVITY_REFERENCE_BY_ID_SUCCESS, payload: data });
    } catch (error) {
        const errorMessage = handleApiError(error, 'Erreur lors du chargement de la référence d\'activité');
        yield put({ type: FETCH_ACTIVITY_REFERENCE_BY_ID_FAILURE, payload: errorMessage });
    }
}

/**
 * Saga pour créer une référence d'activité
 */
function* createActivityReferenceSaga(action) {
    try {
        const { partnerId, referenceData } = action.payload;
        const response = yield call(createActivityReference, partnerId, referenceData);
        const newReference = response.reference || response;
        yield put({ type: CREATE_ACTIVITY_REFERENCE_SUCCESS, payload: newReference });
    } catch (error) {
        const errorMessage = handleApiError(error, 'Erreur lors de la création de la référence d\'activité');
        yield put({ type: CREATE_ACTIVITY_REFERENCE_FAILURE, payload: errorMessage });
    }
}

/**
 * Saga pour mettre à jour une référence d'activité
 */
function* updateActivityReferenceSaga(action) {
    try {
        const { referenceId, referenceData } = action.payload;
        const response = yield call(updateActivityReference, referenceId, referenceData);
        const updatedReference = response.reference || response;
        yield put({ type: UPDATE_ACTIVITY_REFERENCE_SUCCESS, payload: updatedReference });
    } catch (error) {
        const errorMessage = handleApiError(error, 'Erreur lors de la mise à jour de la référence d\'activité');
        yield put({ type: UPDATE_ACTIVITY_REFERENCE_FAILURE, payload: errorMessage });
    }
}

/**
 * Saga pour supprimer une référence (activitylist)
 */
function* deleteActivityReferenceSaga(action) {
    try {
        const referenceId = action.payload;
        const data = yield call(deleteActivityList, referenceId);
        yield put({ type: DELETE_ACTIVITY_REFERENCE_SUCCESS, payload: data || { reference_id: referenceId } });
    } catch (error) {
        const errorMessage = handleApiError(error, 'Erreur lors de la suppression de la référence');
        yield put({ type: DELETE_ACTIVITY_REFERENCE_FAILURE, payload: errorMessage });
    }
}

/**
 * Watcher pour les actions de références d'activité
 */
export function* watchActivityReferencesRequests() {
    yield takeEvery(FETCH_ACTIVITY_REFERENCES_REQUEST, fetchActivityReferencesSaga);
    yield takeEvery(FETCH_ACTIVITY_REFERENCE_BY_ID_REQUEST, fetchActivityReferenceByIdSaga);
    yield takeEvery(CREATE_ACTIVITY_REFERENCE_REQUEST, createActivityReferenceSaga);
    yield takeEvery(UPDATE_ACTIVITY_REFERENCE_REQUEST, updateActivityReferenceSaga);
    yield takeEvery(DELETE_ACTIVITY_REFERENCE_REQUEST, deleteActivityReferenceSaga);
}
